// // utils/pricingPlans.js

export const plansINR = [
  {
    title: "Starter",
    price: "Free",
    subtext: "Try before you buy",
    description: [
      "2 Free Assessment Credits",
      "Complete Personality Reports",
      "Email Support",
      "No Credit Card Required"
    ],
    highlighted: false,
    button: "Start Free",
    popular: false
  },
  {
    title: "Small Team",
    price: "₹1,990",
    subtext: "₹199 per assessment",
    description: [
      "10 Assessment Credits",
      "Detailed Behavioral Analysis",
      "Email Support", 
      "Cancel Anytime",
      "No commitment required"
    ],
    button: "Get Started",
    highlighted: false,
    popular: false
  },
  {
    title: "Growing Team",
    price: "₹8,950",
    subtext: "₹179 per assessment",
    description: [
      "50 Assessment Credits",
      "Detailed Behavioral Analysis",
      "Email Support",
      "Bulk Upload Features",
      "No commitment required"
    ],
    button: "Get Started",
    highlighted: false,
    popular: true
  },
  {
    title: "Scale Business",
    price: "₹31,800",
    subtext: "₹159 per assessment",
    description: [
      "200 Assessment Credits",
      "Detailed Behavioral Analysi",
      "Custom Team Reports",
      "Assess 200 People",
      "Dedicated Account Manager",
      "No commitment required"
    ],
    button: "Get Started",
    highlighted: true,
    popular: false
  },
  {
    title: "Enterprise",
    price: "Custom",
    subtext: "Tailored for your needs",
    description: [
      "Unlimited Assessments",
      "White-Label Solution",
      "Custom AI Models",
      "24/7 Premium Support",
      "On-Premise Deployment"
    ],
    button: "Contact Sales",
    highlighted: false,
    popular: false
  }
];

export const plansUSD = [
  {
    title: "Starter",
    price: "Free",
    subtext: "Try before you buy",
    description: [
      "2 Free Assessment Credits",
      "Complete Personality Reports", 
      "Email Support",
      "No Credit Card Required"
    ],
    highlighted: false,
    button: "Start Free",
    popular: false
  },
  {
    title: "Small Team",
    price: "$49",
    subtext: "$4.90 per assessment",
    description: [
      "10 Assessment Credits",
      "Detailed Behavioral Analysis",
      
      "Email Support", 
      "Cancel Anytime",
      "No commitment required"
    ],
    button: "Get Started",
    highlighted: false,
    popular: false
  },
  {
    title: "Growing Team", 
    price: "$225",
    subtext: "$4.50 per assessment",
    description: [
      "50 Assessment Credits",
      "Detailed Behavioral Analysis",
      "Email Support",
      "Bulk Upload Features",
      "No commitment required"
    ],
    button: "Get Started",
    highlighted: false,
    popular: true
  },
  {
    title: "Scale Business",
    price: "$799",
    subtext: "$3.99 per assessment", 
    description: [
      "200 Assessment Credits",
      "Detailed Behavioral Analysis",
      "Custom Team Reports",
      "Assess 200 People",
      "Dedicated Account Manager",
      "No commitment required"
    ],
    button: "Get Started",
    highlighted: true,
    popular: false
  },
  {
    title: "Enterprise",
    price: "Custom",
    subtext: "Tailored for your needs",
    description: [
      "Unlimited Assessments",
      "White-Label Solution", 
      "Custom AI Models",
      "24/7 Premium Support",
      "On-Premise Deployment"
    ],
    button: "Contact Sales",
    highlighted: false,
    popular: false
  }
];

// utils/pricingPlans.js

// export const plansINR = [

//      {
//     title: "2 Assessments",
//     price: "Free Plan",
//     sub_text: "Ideal for small businesses",
//     description: [
//       "2 Free Credits",
//       "Quick setup",
//       "Detailed Assessment Report",
//       "No commitment required",
//     ],
//     highlighted: false,
//   button:" Free Plan"
//   },
//     {
//         title: "10 Assessments",
//         price: "₹1,990",
//         subtext: "₹199 per assessment",
//         description: [
//             " Ideal for small businesses",
//             " Quick setup",
//             " Detailed Assessment Report",
//              "Assess 10 People",
//             " Includes email support",
//             " No commitment required",
//         ],
//         button: "Buy 10 Assessments",
//         // button: "Start Your Free Trial",
//         highlighted: false,
//         yearlyOnly: false
//     },
//     {
//         title: "50 Assessments",
//         price: "₹8,950",
//         subtext: "₹179 per assessment",
//         description: [
//             " Better value per assessment",
//             " Supports mid-sized teams",
//             " Detailed Assessment Report",
//              "Assess 50 People",
//             " Includes email support",
//             " No commitment required"
//         ],
//         button: "Buy 50 Assessments",
//         // button: "Start Your Free Trial",
//         highlighted: false,
//         yearlyOnly: false,
//         popular: true
//     },
//     {
//         title: "200 Assessments",
//         price: "₹31,800",
//         subtext: "₹159 per assessment",
//         description: [
//             " Most Popular Choice",
//             " Recommended for growing teams",
//             " Detailed Assessment Report",
//              "Assess 200 People",
//             " Analytics dashboard",
//             " Priority email support",
//             " No commitment required",
//         ],
//         button: "Buy 200 Assessments",
//         // button: "Start Your Free Trial",
//         highlighted: true,
//         yearlyOnly: false
//     },
   
//     {
//         title: "1000 Assessments",
//         price: "₹99,000",
//         subtext: "₹99 per assessment",
//         description: [
//             " Supports Large Businesses",
//             " Detailed Assessment Report",
//              "Assess 1000 People",
//             " Analytics dashboard",
//             " Dedicated onboarding",
//             " Premium Support",
//             " No commitment required"
//         ],
//         button: "Buy 1000 Assessments",
//         // button: "Start Your Free Trial",
//         highlighted: false,
//         yearlyOnly: false
//     },
//     {
//         title: "1000+ Assessments",
//         price: "Custom Pricing",
//         subtext: "Tailored for large organizations",
//         description: [
//             "Tailor your plan to fit your needs",
//             "Contact us for further information"
//         ],
//         button: "Contact Us",
//         highlighted: false,
//         yearlyOnly: false,
//     }
// ];

// export const plansUSD = [

//      {
//     title: "2 Assessments",
//     price: "Free Plan",
//     sub_text: "Ideal for small businesses",
//     description: [
//       "2 Free Credits",
//       "Quick setup",
//       "Detailed Assessment Report",
//       "No commitment required",
//     ],
//     highlighted: false,
//   button:" Free Plan"
//   },
//     {
//         title: "10 Assessments",
//         price: "$49.90",
//         subtext: "$4.99 per assessment",
//         description: [
//             " Ideal for small businesses",
//             " Quick setup",
//             " Detailed Assessment Report",
//             "Assess 10 People",
//             " Includes email support",
//             " No commitment required",
//         ],
//         button: "Buy 10 Assessments",
//         // button: "Start Your Free Trial",
//         highlighted: false,
//         yearlyOnly: false
//     },
//     {
//         title: "50 Assessments",
//         price: "$224.50",
//         subtext: "$4.49 per assessment",
//         description: [
//             " Better value per assessment",
//             " Supports mid-sized teams",
//             " Detailed Assessment Report",
//              "Assess 50 People",
//             " Includes email support",
//             " No commitment required"
//         ],
//         button: "Buy 50 Assessments",
//         // button: "Start Your Free Trial",
//         highlighted: false,
//         yearlyOnly: false,
//         popular: true
//     },
//     {
//         title: "200 Assessments",
//         price: "$798.00",
//         subtext: "$3.99 per assessment",
//         description: [
//             " Most Popular Choice",
//             " Recommended for growing teams",
//             " Detailed Assessment Report",
//              "Assess 200 People",
//             " Analytics dashboard",
//             " Priority email support",
//             " No commitment required",
//         ],
//         button: "Buy 200 Assessments",
//         // button: "Start Your Free Trial",
//         highlighted: true,
//         yearlyOnly: false
//     },
//     {
//         title: "500 Assessments",
//         price: "$1,745.00",
//         subtext: "$3.49 per assessment",
//         description: [
//             " Supports Mid to Large Businesses",
//             " Detailed Assessment Report",
//              "Assess 500 People",
//             " Analytics dashboard",
//             " Dedicated onboarding",
//             " Priority email support",
//             " No commitment required"
//         ],
//         button: "Buy 500 Assessments",
//         // button: "Start Your Free Trial",
//         highlighted: false,
//         yearlyOnly: false
//     },
//     {
//         title: "1000 Assessments",
//         price: "$2,990.00",
//         subtext: "$2.99 per assessment",
//         description: [
//             " Supports Large Businesses",
//             " Detailed Assessment Report",
//              "Assess 1000 People",
//             " Analytics dashboard",
//             " Dedicated onboarding",
//             " Premium Support",
//             " No commitment required"
//         ],
//         button: "Buy 1000 Assessments",
//         // button: "Start Your Free Trial",
//         highlighted: false,
//         yearlyOnly: false
//     },
//     {
//         title: "1000+ Assessments",
//         price: "Custom Pricing",
//         subtext: "Tailored for large organizations",
//         description: [
//             "Tailor your plan to fit your needs",
//             "Contact us for further information"
//         ],
//         button: "Contact Us",
//         highlighted: false,
//         yearlyOnly: false,
//     }
// ];
